export default __webpack_public_path__ + "static/media/img3.246addc8.png";